import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { ENDPOINTS } from 'features/quick-entry/constants/endpoints';
import strings from 'strings';

export const COPIES = strings.inventory.quickEntry.drawers.candidate;
export const WARNING_CLOSE_DIALOG = strings.inventory.quickEntry.drawers.warningCloseDialog;
export const DELETE_API_VERSION = 1;

export const FORM_FIELDS = {
  name: 'name',
  notes: 'notes',
  files: 'files'
};

export const DEFAULT_FORM_VALUES = {
  [FORM_FIELDS.name]: '',
  [FORM_FIELDS.notes]: COPIES.notesTemplate,
  [FORM_FIELDS.files]: []
};

export const UPLOAD_CATEGORIES = [
  { id: 46, title: COPIES.uploads.resume },
  { id: 47, title: COPIES.uploads.candidateDataSheet },
  { id: 48, title: COPIES.uploads.handwrittenNotes }
];

export const CANDIDATE_QUICK_ENTRY_STATUSES = {
  draft: 'draft',
  readyToProcess: 'readyToProcess'
};

export const SUCCESS_STATUS_CODES = [
  HTTPStatusCodes.Ok,
  HTTPStatusCodes.Created,
  HTTPStatusCodes.NoContent
];

export const SUBMIT_MODE_CONFIG = {
  create: {
    action: 'created',
    method: 'post',
    getEndpoint: () => ENDPOINTS.quickEntries
  },
  edit: {
    action: 'updated',
    method: 'patch',
    getEndpoint: id => ENDPOINTS.quickEntriesById.replace(':id', id)
  }
};
